import React from 'react'

import { Box } from '@chakra-ui/react'

import { ColorScheme } from '../TypeaheadSearch/TypeaheadSearch.styles'

type SearchIconProps = {
  colorScheme: ColorScheme
  color?: string
  size?: number
}

export const SearchIcon = ({
  colorScheme,
  color,
  size = 20,
}: SearchIconProps) => {
  return (
    <Box
      alignItems='center'
      color={
        color ??
        (colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary')
      }
      display='flex'
      flexShrink={0}
      height={`${size}px`}
      lineHeight={0}
      width={`${size}px`}
    >
      <svg
        fill='none'
        height={size}
        viewBox='0 0 16 16'
        width={size}
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M14.5 14.5L11.2375 11.2375M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Box>
  )
}
